import moment from "moment";
import { ICheckboxStyles } from "office-ui-fabric-react";
export const isStringValidated = (value) => {
    if (value == null || value == undefined || value == "") {
      return false;
    } else {
      return true;
    }
  };
  
  export const isArrayValidated = (value) => {
    if (value == null || value == undefined || value.length === 0) {
      return false;
    } else {
      return true;
    }
  };
  

  export const SelectTheme = (theme) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary25: "#F0F0F0",
      primary: "hsl(0,0%,80%)",
    },
  });
  export const onFormatDate = (date?: Date): string => {
    return !date ? "" : moment(new Date(date)).format("MM/DD/YYYY");
  };


  export const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color:"var(--layoutTextColor) !important",
      backgroundColor: state.isSelected ? 'var(--textIconColor)' : 'white', // change background color of selected option
      ":hover": {
          backgroundColor :"var(--lightdarkBGTable)",
          cursor:"pointer",
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }),
    input: (provided) => ({
      ...provided,
      color: 'var(--layoutTextColor) !important'
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'var(--layoutBackground) !important',
      color: 'var(--layoutTextColor) !important',
      zIndex: "1000"
    }),
  };


    export const checkboxStyles: ICheckboxStyles = {
    text: {
      // fontWeight: 600,
      marginRight: "15px",
    },
    checkmark: {
      // color: 'var(--lightdarkColor)',
      color:  "var(--lightdarkBGGray)",
      // backgroundColor: 'var(--lightdarkBGGray)',
      backgroundColor: "#fff",
      padding: "3px",
      width: "20px",
    },
    checkbox: {
      color: "var(--lightdarkBGGray)",
      backgroundColor: "#fff",
      border: "1px solid #333 !important",
    },
    root: {
      // marginLeft: "40px",
      marginTop: "5px",
      "&:hover": {
        ".ms-Checkbox-checkbox": {
          color: "var(--lightdarkBGGray)",
          backgroundColor: "#fff",
          // backgroundColor: 'var(--lightdarkBGGray)',
          // color: 'var(--lightdarkColor)',
        },
      },
    },
  };

export const getTaskDueDate = (): Date => {
        const taskDueDate = new Date();
        taskDueDate.setDate(taskDueDate.getDate() + 3);
        return taskDueDate;
};


 export const  convertToEncodedHTML=(obj)=> {
  const highlightHTML = `<p><span style="background-color: rgb(255, 255, 0); color: rgb(0, 0, 0);">${obj.highlightText}</span><span style="color: rgb(0, 0, 0);">&nbsp;</span></p>`;
  const commentHTML = `<p><br></p><p>Comments: ${obj.CommentText}</p><p><br></p>`;
  
  const fullHTML = highlightHTML + commentHTML;
  
  return encodeURIComponent(fullHTML);
}     

 export function sortAlphaNum(a, b) {
      const reA = /[^a-zA-Z]/g;
    const reN = /[^0-9]/g;
        const aA = a.text.replace(reA, "");
        const bA = b.text.replace(reA, "");

        if (aA === bA) {
            const aN = parseInt(a.text.replace(reN, ""), 10);
            const bN = parseInt(b.text.replace(reN, ""), 10);

            return aN === bN ? 0 : aN > bN ? 1 : -1;
        } else {
            return aA > bA ? 1 : -1;
        }
    }